module.exports = __webpack_public_path__ + "img/git-branch.c3248604.svg";